{
  "components": {
    "AddInventoryModal": {
      "add_inventory": "Add Inventory",
      "select_the_room_type_and_applicable": "Select the room type and applicable inventory rules",
      "room_type": "Room Type*",
      "select_room_type": "Select room type...",
      "premium_overwater_villa": "Premium Overwater Villa",
      "water_villa": "Water Villa",
      "from": "From*",
      "attrs": {
        "mmddyyyy": "MM/DD/YYYY",
        "enter_daily_available_rooms": "Enter daily available rooms"
      },
      "to": "To*",
      "daily_available_rooms": "Daily Available Rooms*",
      "closed_to_arrival_dates_in_this": "Closed to Arrival dates in this period",
      "add": "Add",
      "closed_to_departure_dates_in_this": "Closed to Departure dates in this period",
      "blackout_dates_in_this_period": "Blackout dates in this period",
      "create": "Create"
    },
    "ConversionRatePieChart": {
      "overall_conversion": "Overall Conversion:"
    },
    "CampaignList": {
      "campaign": "Campaign",
      "code_strategy": "Code Strategy",
      "discount": "Discount",
      "budget_usage": "Budget Usage",
      "expiry_date": "Expiry Date",
      "status": "Status",
      "generated_codes": "Generated Codes",
      "carried_by": "Carried by",
      "no_campaigns_found_matching_your_criteria": "No campaigns found matching your criteria."
    },
    "getOrderStatusBadge": {
      "new": "New",
      "in_progress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "open": "Open"
    },
    "OrderCard": {
      "x": "x"
    },
    "OrderSettings": {
      "order_settings": "Order settings",
      "order_states": "Order states",
      "add_order_status": "Add order status",
      "order_management": "Order management",
      "show_unpaid_orders": "Show unpaid orders",
      "show_orders_which_are_still_awaiting": "Show orders which are still awaiting payment from your\n                    customer in your workflows. When you change this setting, it\n                    will only apply to new orders that are submitted."
    },
    "ShopDashboard": {
      "revenue_trend": "Revenue Trend",
      "last_12_months": "Last 12 months",
      "usd": ": MYR",
      "usd_2": "MYR",
      "usd_0": "MYR 0",
      "orders_trend": "Orders Trend",
      "orders": "orders",
      "top_selling_products": "Top Selling Products",
      "sold": "sold",
      "revenue": "Revenue",
      "customer_insights": "Customer Insights",
      "new_customers": "New Customers",
      "returning_customers": "Returning Customers",
      "avg_order_value": "Avg. Order Value",
      "conversion_rate": "Conversion Rate"
    }
  },
  "pages": {
    "CampaignDetails": {
      "campaign_not_found": "Campaign not found",
      "the_campaign_you_are_looking_for": "The campaign you are looking for does not exist or has been removed.",
      "back_to_campaigns": "Back to Campaigns",
      "campaign_id": "Campaign ID:",
      "export_csv": "Export CSV",
      "edit": "Edit",
      "delete": "Delete",
      "export_campaign_data": "Export Campaign Data",
      "select_time_period_for_export": "Select time period for export:",
      "the_export_will_include": "The export will include:",
      "daily_code_usage_statistics": "Daily code usage statistics",
      "conversion_metrics": "Conversion metrics",
      "transaction_volumes_and_amounts": "Transaction volumes and amounts",
      "user_engagement_data": "User engagement data",
      "cancel": "Cancel",
      "export_data": "Export Data",
      "exporting": "Exporting...",
      "export_complete": "Export Complete",
      "try_again": "Try Again",
      "generate_code_batch": "Generate Code Batch",
      "number_of_codes_to_generate": "Number of Codes to Generate",
      "usage_limit_per_code": "Usage Limit Per Code",
      "how_many_times_each_individual_code": "How many times each individual code can be redeemed.",
      "generate_codes": "Generate Codes",
      "transaction_volume": "Transaction Volume",
      "from": "From",
      "transactions": "transactions",
      "volume_roi": "Volume ROI",
      "against_budget_of": "Against budget of",
      "campaign_details": "Campaign Details",
      "category": "Category",
      "campaign_code": "Campaign Code",
      "discount_carried_by": "Discount Carried By",
      "description": "Description",
      "constraints_targeting": "Constraints & Targeting",
      "start_date": "Start Date",
      "transaction_value_limits": "Transaction Value Limits",
      "discount_limits": "Discount Limits",
      "valid_days": "Valid Days",
      "payment_methods": "Payment Methods",
      "budget_enforcement": "Budget Enforcement",
      "budget_type": "Budget Type",
      "customer_usage_limits": "Customer Usage Limits",
      "card_targeting": "Card Targeting",
      "analytics": "Analytics",
      "code_batches": "Code Batches",
      "batches": "batches",
      "generate_batch": "Generate Batch",
      "total_codes": "Total Codes",
      "total_redeemed": "Total Redeemed",
      "redemption_rate": "Redemption Rate",
      "batch_id": "Batch ID",
      "date_created": "Date Created",
      "codes_generated": "Codes Generated",
      "usage_limit": "Usage Limit",
      "redemption": "Redemption",
      "actions": "Actions",
      "per_code": "× per code",
      "individual_codes": "Individual Codes —",
      "codes_shown": "codes shown •",
      "available": "available,",
      "redeemed": "redeemed",
      "attrs": {
        "search_code": "Search code..."
      },
      "export_codes": "Export Codes",
      "code": "Code",
      "times_used": "Times Used",
      "last_used": "Last Used"
    },
    "renderAnalyticsContent": {
      "conversion_funnel": "Conversion Funnel",
      "conversion_rates": "Conversion Rates",
      "code_usage_over_time_last_30": "Code Usage Over Time (Last 30 Days)",
      "payment_volume_over_time_last_30": "Payment Volume Over Time (Last 30 Days)"
    },
    "CountryMultiSelect": {
      "select_countries": "Select countries...",
      "attrs": {
        "search_countries": "Search countries..."
      },
      "no_countries_found": "No countries found."
    },
    "CampaignForm": {
      "attrs": {
        "title": "Title",
        "eg_summer_sale_2025": "e.g. Summer Sale 2025",
        "brief_description_of_the_campaign": "Brief description of the campaign...",
        "single_global_code": "Single Global Code",
        "one_code_that_can_be_used": "One code that can be used by multiple customers (e.g. SUMMER25)",
        "unique_bulk_codes": "Unique Bulk Codes",
        "system_generates_multiple_unique_codes_for": "System generates multiple unique codes for single use",
        "global_campaign_code": "Global Campaign Code",
        "eg_summer25": "e.g. SUMMER25",
        "discount_type": "Discount Type",
        "fixed_amount": "Fixed Amount",
        "a_specific_usd_amount_off_the": "A specific MYR amount off the total purchase",
        "percentage": "Percentage",
        "a_percentage_off_the_total_purchase": "A percentage off the total purchase",
        "fixed_discount_amount": "Fixed Discount Amount",
        "discount_percentage": "Discount Percentage",
        "valid_for_which_payment_methods": "Valid for which payment methods",
        "fixed_budget": "Fixed Budget",
        "set_a_onetime_total_budget_for": "Set a one-time total budget for the campaign",
        "recurring_budget": "Recurring Budget",
        "budget_resets_automatically_each_period_until": "Budget resets automatically each period until expiry",
        "total_budget": "Total Budget",
        "recurring_period": "Recurring Period",
        "select_one": "-- Select One --",
        "recurring_budget_amount": "Recurring Budget Amount",
        "ddmmyyyy": "DD/MM/YYYY",
        "min_discount": "Min Discount",
        "max_discount": "Max Discount",
        "min_transaction_value": "Min Transaction Value",
        "max_transaction_value": "Max Transaction Value",
        "limit_usage_to_specific_customers_localcustomerid": "Limit usage to specific customers (localCustomerId)",
        "enter_a_commaseparated_list_of_customer": "Enter a comma-separated list of customer IDs",
        "eg_cust001_cust002_cust003_cust004": "e.g. CUST001, CUST002, CUST003, CUST004",
        "remove_rule": "Remove rule",
        "eg_411111_422222_553344": "e.g. 411111, 422222, 553344",
        "valid_on_which_days": "Valid on which days"
      },
      "discount_configuration": "Discount Configuration",
      "select_the_payment_methods_this_campaign": "Select the payment methods this campaign applies to. If none are\n                selected, it applies to all.",
      "budget": "Budget",
      "strictly_enforce_budget": "Strictly enforce budget",
      "campaign_constraints": "Campaign Constraints",
      "targeting": "Targeting",
      "commaseparated_list_of_customer_ids_leave": "Comma-separated list of customer IDs. Leave empty for no\n                restriction.",
      "card_targeting_rules": "Card Targeting Rules",
      "no_rules_all_cards_accepted": "No rules — all cards accepted",
      "no_card_targeting_rules_configured": "No card targeting rules configured",
      "add_rules_to_restrict_which_cards": "Add rules to restrict which cards are eligible for this\n                      campaign",
      "commaseparated_list_of_6_or_8": "Comma-separated list of 6 or 8 digit BINs",
      "add_card_rule": "Add Card Rule",
      "all_available_rule_types_have_been": "All available rule types have been added",
      "nothing_selected_means_valid_on_all": "Nothing selected means valid on all days"
    },
    "Campaigns": {
      "campaigns": "Campaigns",
      "manage_your_discount_codes_and_promotional": "Manage your discount codes and promotional campaigns",
      "create_campaign": "Create Campaign",
      "active_campaigns": "Active Campaigns",
      "total_redemptions": "Total Redemptions",
      "budget_allocated": "Budget Allocated",
      "budget_used": "Budget Used",
      "attrs": {
        "search_campaigns_by_name_id_or": "Search campaigns by name, ID, or code..."
      },
      "status": "Status:",
      "all_statuses": "All Statuses",
      "active": "Active",
      "inactive": "Inactive",
      "expired": "Expired"
    },
    "Inventory": {
      "inventory": "Inventory",
      "room_type": "Room Type",
      "available_rooms": "Available Rooms",
      "cta": "CTA",
      "ctd": "CTD",
      "blo": "BLO"
    },
    "OrderDetail": {
      "order": "Order #",
      "send": "Send",
      "download": "Download",
      "mark_fulfilled": "Mark Fulfilled",
      "print_order": "Print Order",
      "edit_order": "Edit Order",
      "cancel_order": "Cancel Order",
      "order_items": "Order Items",
      "quantity": "Quantity:",
      "subtotal": "Subtotal",
      "shipping": "Shipping",
      "tax": "Tax",
      "total": "Total",
      "order_timeline": "Order Timeline",
      "order_placed": "Order placed",
      "at": "at",
      "processing_started": "Processing started",
      "order_is_being_processed": "Order is being processed",
      "processing": "Processing",
      "waiting_to_be_processed": "Waiting to be processed",
      "order_has_been_fulfilled": "Order has been fulfilled",
      "waiting_to_be_completed": "Waiting to be completed",
      "customer_information": "Customer Information",
      "customer": "Customer #",
      "email": "Email",
      "mobile": "Mobile",
      "additional_phone": "Additional Phone",
      "shipping_address": "Shipping Address",
      "payment_information": "Payment Information",
      "payment_method": "Payment Method",
      "payment_status": "Payment Status",
      "transaction_id": "Transaction ID",
      "transaction_status": "Transaction Status",
      "shipping_status": "Shipping Status",
      "customer_notes": "Customer Notes:"
    },
    "Orders": {
      "orders": "Orders",
      "settings": "Settings",
      "total_orders": "Total Orders",
      "total_amount": "Total Amount",
      "across": "Across",
      "attrs": {
        "search_orders": "Search orders..."
      },
      "all_shops": "All Shops",
      "no_orders_found_matching_your_criteria": "No orders found matching your criteria.",
      "order": "Order",
      "date": "Date",
      "customer": "Customer",
      "shop": "Shop",
      "payment": "Payment",
      "view_details": "View Details",
      "email_customer": "Email Customer",
      "archive_order": "Archive Order"
    },
    "SaleDetail": {
      "back_to_sales": "Back to Sales",
      "download_receipt": "Download Receipt",
      "refund": "Refund",
      "name": "Name",
      "phone": "Phone",
      "transaction_date": "Transaction Date",
      "source": "Source",
      "merchant_information": "Merchant Information",
      "merchant_name": "Merchant Name",
      "merchant_id": "Merchant ID",
      "related_documents": "Related Documents",
      "invoice": "Invoice",
      "transaction_lifecycle": "Transaction Lifecycle"
    },
    "Sales": {
      "total_volume": "Total Volume",
      "total_transactions": "Total Transactions",
      "successful": "Successful",
      "success_rate": "Success Rate",
      "attrs": {
        "search_by_transaction_id_customer_name": "Search by transaction ID, customer name, or email...",
        "no_limit": "No limit"
      },
      "filters": "Filters",
      "export": "Export",
      "advanced_filters": "Advanced Filters",
      "clear_all": "Clear all",
      "all_status": "All Status",
      "pending": "Pending",
      "failed": "Failed",
      "refunded": "Refunded",
      "all_sources": "All Sources",
      "payment_link": "Payment Link",
      "qr_code": "QR Code",
      "tap_to_phone": "Tap to Phone",
      "pos_terminal": "POS Terminal",
      "recurring": "Recurring",
      "virtual_terminal": "Virtual Terminal",
      "all_methods": "All Methods",
      "card": "Card",
      "wallet": "Wallet",
      "bank_transfer": "Bank Transfer",
      "cash": "Cash",
      "date_from": "Date From",
      "date_to": "Date To",
      "min_amount_usd": "Min Amount (MYR)",
      "max_amount_usd": "Max Amount (MYR)",
      "date_time": "Date & Time",
      "payment_category": "Payment Category",
      "amount": "Amount",
      "view_details": "View details",
      "no_transactions_found": "No transactions found"
    },
    "ShopDetails": {
      "shop_name": "Shop Name",
      "attrs": {
        "enter_shop_name": "Enter shop name",
        "logo_character_or_emoji": "Logo character or emoji",
        "describe_your_shop": "Describe your shop",
        "preview": "Preview",
        "edit_shop": "Edit Shop",
        "shop_link": "Shop Link",
        "search_products": "Search products..."
      },
      "shop_logo": "Shop Logo",
      "enter_a_single_character_or_emoji": "Enter a single character or emoji to use as shop logo",
      "appearance_channels": "Appearance & Channels",
      "logo_background_color": "Logo Background Color",
      "shop_channels": "Shop Channels",
      "ecommerce_online_shop": "E-Commerce (Online Shop)",
      "point_of_sale_physical_store": "Point of Sale (Physical Store)",
      "back_to_products": "Back to products",
      "product_information": "Product Information",
      "product_name": "Product Name",
      "sku": "SKU",
      "pricing_inventory": "Pricing & Inventory",
      "price": "Price",
      "discounted_price": "Discounted Price",
      "stock_quantity": "Stock Quantity",
      "product_image": "Product Image",
      "image_url": "Image URL",
      "no_image": "No image",
      "all_shops": "All shops",
      "pos": "POS",
      "ecommerce": "E-Commerce",
      "products": "Products",
      "active_items_in_catalog": "Active items in catalog",
      "from_last_month": "% from last month",
      "total_completed_orders": "Total completed orders",
      "accepting_orders": "Accepting Orders",
      "currently_closed": "Currently Closed",
      "toggle_in_edit_mode": "Toggle in edit mode",
      "all_categories": "All Categories",
      "add_product": "Add Product",
      "stock": "Stock:",
      "product": "Product",
      "stock_2": "Stock",
      "product_categories": "Product Categories",
      "add_category": "Add Category"
    },
    "getStatusBadge": {
      "closed": "Closed"
    },
    "Shops": {
      "shops": "Shops",
      "add_shop": "Add shop",
      "total_shops": "Total Shops",
      "open": "open ·",
      "closed": "closed",
      "total_revenue": "Total Revenue",
      "shops_2": "shops",
      "total_products": "Total Products",
      "all_shops_combined": "All shops combined",
      "attrs": {
        "search_shops": "Search shops..."
      },
      "channels": "Channels",
      "share_shop": "Share Shop",
      "close_shop": "Close Shop",
      "open_shop": "Open Shop",
      "delete_shop": "Delete Shop",
      "no_shops_found_matching_your_criteria": "No shops found matching your criteria.",
      "share": "Share",
      "scan_this_qr_code_to_visit": "Scan this QR code to visit",
      "back_to_share_options": "Back to share options",
      "generate_qr_code": "Generate QR Code",
      "close": "Close"
    }
  }
}
